import userConfigurationNameType from 'owa-service/lib/factory/userConfigurationNameType';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
export default function getMailboxExportUserConfigurationName() {
    return userConfigurationNameType({
        Name: 'MailExportRequest',
        BaseFolderId: distinguishedFolderId({ Id: 'root' }),
    });
}
//# sourceMappingURL=getMailboxExportUserConfigurationName.js.map